import React from 'react';
import Alert from 'react-bootstrap/Alert';

import BaseWidget from '../base-widget/BaseWidget';
import Loader from "../../loader/Loader";
import {getSchemaInfo} from "../../../utils/soml-utils";
import {SchemaInfo} from "../../../types/SchemaInfo";

import './SchemaInformationWidget.scss';

type SchemaInformationWidgetProps = {
  schema?: string;
  loading?: boolean;
  error?: any;
}

class SchemaInformationWidget extends React.Component<SchemaInformationWidgetProps> {

  render() {
    const schemaInfo: SchemaInfo | undefined = SchemaInformationWidget.getInfo(this.props.schema);
    return (
      <BaseWidget title="Schema Information" className="SchemaInformationWidget">
        {
          this.props.loading && <Loader size='lg' block={true}/>
        }
        {
          !this.props.loading && schemaInfo && <SchemaInfoView schemaInfo={schemaInfo}/>
        }
        {
          this.props.error && <Alert variant="danger">{this.props.error}</Alert>
        }
      </BaseWidget>
    );
  }

  private static getInfo(schema: any) {
    if (schema) {
      return getSchemaInfo(schema);
    }
    return undefined;
  }
}

function SchemaInfoView(props: { schemaInfo: SchemaInfo }) {
  return <dl className="schema-info">
    <dt className="objects-total">Objects: <span
      className="count">{props.schemaInfo.objects.total}</span></dt>
    <dd className="interfaces">Interfaces: <span
      className="count">{props.schemaInfo.objects.interface}</span></dd>
    <dd className="concrete-objects">Concrete objects: <span
      className="count">{props.schemaInfo.objects.concrete}</span></dd>

    <dt className="properties-total">Properties: <span
      className="count">{props.schemaInfo.properties.total}</span></dt>
    <dd className="data-properties">Data properties: <span
      className="count">{props.schemaInfo.properties.dataProperty}</span></dd>
    <dd className="object-properties">Object properties: <span
      className="count">{props.schemaInfo.properties.objectProperty}</span></dd>

    <dt className="roles-total">Roles: <span className="count">{props.schemaInfo.roles.total}</span>
    </dt>
  </dl>
}

export default SchemaInformationWidget;
